import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import InstallWebPackageManagers from "../install-web-package-managers.mdx";
import Tab from "components/Tab";
import AppRouterSetup from "./app-router-setup.mdx";
import PagesRouterSetup from "./pages-router-setup.mdx";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Install `}<inlineCode parentName="p">{`posthog-js`}</inlineCode>{` using your package manager:`}</p>

    <InstallWebPackageManagers mdxType="InstallWebPackageManagers" />
    <p>{`Add your environment variables to your `}<inlineCode parentName="p">{`.env.local`}</inlineCode>{` file and to your hosting provider (e.g. Vercel, Netlify, AWS). You can find your project API key in your `}<a parentName="p" {...{
        "href": "https://app.posthog.com/project/settings"
      }}>{`project settings`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell",
        "metastring": "file=.env.local",
        "file": ".env.local"
      }}>{`NEXT_PUBLIC_POSTHOG_KEY=<ph_project_api_key>
NEXT_PUBLIC_POSTHOG_HOST=<ph_client_api_host>
`}</code></pre>
    <p>{`These values need to start with `}<inlineCode parentName="p">{`NEXT_PUBLIC_`}</inlineCode>{` to be accessible on the client-side.`}</p>
    <h2 {...{
      "id": "integration"
    }}>{`Integration`}</h2>

    <p>{`Next.js 15.3+ provides the `}<a parentName="p" {...{
        "href": "https://nextjs.org/docs/app/api-reference/file-conventions/instrumentation-client"
      }}><inlineCode parentName="a">{`instrumentation-client.ts|js`}</inlineCode></a>{` file for a quick, lightweight setup. Add it to the root of your Next.js app (for both app and pages router) and initialize PostHog in it like this:`}</p>
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-js",
          "metastring": "file=instrumentation-client.js",
          "file": "instrumentation-client.js"
        }}>{`import posthog from 'posthog-js'

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
  api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  defaults: '<ph_posthog_js_defaults>'
});
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-ts",
          "metastring": "file=instrumentation-client.ts",
          "file": "instrumentation-client.ts"
        }}>{`import posthog from 'posthog-js'

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  defaults: '<ph_posthog_js_defaults>'
});
`}</code></pre>
    </MultiLanguage>
    <details>
      <summary>Using Next.js 15.2 or older?</summary>
      <p>{`Older versions of Next.js don't support the `}<inlineCode parentName="p">{`instrumentation-client.ts|js`}</inlineCode>{` file. You can use the following setup instead:`}</p>
      <Tab.Group tabs={['App router', 'Pages router']}>
  <Tab.List>
    <Tab mdxType="Tab">App router</Tab>
    <Tab mdxType="Tab">Pages router</Tab>
  </Tab.List>
  <Tab.Panels>
      <Tab.Panel>
        <AppRouterSetup mdxType="AppRouterSetup" />
      </Tab.Panel>
      <Tab.Panel>
        <PagesRouterSetup mdxType="PagesRouterSetup" />
      </Tab.Panel>
  </Tab.Panels>
      </Tab.Group>
    </details>
    <details>
      <summary>Bootstrapping with <code>instrumentation-client</code></summary>
      <p>{`When using `}<inlineCode parentName="p">{`instrumentation-client`}</inlineCode>{`, the values you pass to `}<inlineCode parentName="p">{`posthog.init`}</inlineCode>{` remain fixed for the entire session. This means bootstrapping only works if you evaluate flags `}<strong parentName="p">{`before your app renders`}</strong>{` (for example, on the server).  `}</p>
      <p>{`If you need flag values after the app has rendered, you’ll want to:  `}</p>
      <ul>
        <li parentName="ul">{`Evaluate the flag on the server and pass the value into your app, or  `}</li>
        <li parentName="ul">{`Evaluate the flag in an earlier page/state, then store and re-use it when needed.  `}</li>
      </ul>
      <p>{`Both approaches avoid flicker and give you the same outcome as bootstrapping, as long as you use the same `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{` across client and server.  `}</p>
      <p>{`See the `}<a parentName="p" {...{
          "href": "/docs/feature-flags/bootstrapping"
        }}>{`bootstrapping guide`}</a>{` for more information.`}</p>
    </details>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      